module.exports = __webpack_public_path__ + "img/loading.252cde53.gif";